import React from 'react';
import BlockContent from '@sanity/block-content-to-react';

const serializers = {
  types: {
    block: (props: any) => {
      const { style = 'normal' } = props.node;

      if (/^h\d/.test(style)) {
        const level = style.replace(/[^\d]/g, '');
        return React.createElement(
          style,
          { className: `heading-${level}` },
          props.children
        );
      }

      if (style === 'blockquote') {
        return <blockquote>- {props.children}</blockquote>;
      }

      // Fall back to default handling
      // @ts-ignore: Unreachable code error
      return BlockContent.defaultSerializers.types.block(props);
    },
    code: (props: any) => (
      <pre data-language={props.node.language}>
        <code>{props.node.code}</code>
      </pre>
    ),
  },
  list: (props: any) =>
    props.type === 'bullet' ? (
      <ul>{props.children}</ul>
    ) : (
      <ol>{props.children}</ol>
    ),
  listItem: (props: any) =>
    props.type === 'bullet' ? (
      <li>{props.children}</li>
    ) : (
      <li>{props.children}</li>
    ),
  marks: {
    strong: (props: any) => <strong>{props.children}</strong>,
    em: (props: any) => <em>{props.children}</em>,
    code: (props: any) => <code>{props.children}</code>,
    sup: (props: any) => <sup>{props.children}</sup>,
    sub: (props: any) => <sub>{props.children}</sub>,
  },
};

export const CustomBlockContent = ({ blocks }: any) => (
  <BlockContent
    blocks={blocks}
    // @ts-ignore: Unreachable code error
    serializers={serializers}
    projectId="s8nj0wth"
    dataset="next"
    imageOptions={{
      width: 500,
      height: 500,
    }}
  />
);
